import React from "react";
import {useNavigate} from "react-router-dom";
import {AuthContainer} from "../Auth.styled";
import {brand} from "../../../theme/brand";
import { usePageTitle } from '../../../hooks/usePageTitle';
import { PageTitleKeys } from '../../../config/routeConstants';
import {useTranslation} from 'react-i18next';
import LogoWithLanguageSwitcher from '../../../components/common/LogoWithLanguageSwitcher';
import {Button} from "@mui/material";
import {Header, StyledCard, Subtext} from "./ThankYouForRegistration.styled";

const ThankYouForRegistration = () => {
    usePageTitle(PageTitleKeys.ThankYouForRegistration);
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <AuthContainer role="region" aria-labelledby="thank-you-title">
            <LogoWithLanguageSwitcher src={brand.logo} alt={t('auth.logo.alt')} clickable={false} />

            <StyledCard>
                <Header id="thank-you-title">{t('thankYouForRegistration.title')}</Header>

                <Subtext>{t('thankYouForRegistration.subtitle')}</Subtext>

                <Button
                    variant="contained"
                    fullWidth
                    onClick={() => navigate("/login")}
                    aria-label={t('thankYouForRegistration.backButton') as string}
                >
                    {t('thankYouForRegistration.backButton')}
                </Button>
            </StyledCard>
        </AuthContainer>
    );
};

export default ThankYouForRegistration;
